import { ru, uk, enUS } from 'date-fns/locale';

export const REGULAR_EVENT_TYPES = [
  { type: 'TimeOff',  color: '#00B8D9', icon: '🏖️' },
  { type: 'SickLeave', color: '#6554C0', icon: '🏥' },
  { type: 'Birthday',  color: '#E67E22', icon: '🎂' },
  { type: 'Leave',     color: '#36B37E', icon: '📅' },
] as const;

export const PROJECT_EVENT_COLOR = '#FF6B6B';
export const CRM_EVENT_COLOR = '#d48806';

export const RECURRENCE_OPTIONS = [
  { value: 'once',    label: 'One Time', icon: '📅' },
  { value: 'daily',   label: 'Daily',    icon: '🔄' },
  { value: 'weekly',  label: 'Weekly',   icon: '📆' },
  { value: 'monthly', label: 'Monthly',  labelShort: 'Mo', icon: '🗓️' },
  { value: 'yearly',  label: 'Yearly',   icon: '📊' },
] as const;

export const MOCK_PROJECTS = [
  { id: '1', name: 'Project Alpha', slug: 'project-alpha' },
  { id: '2', name: 'Project Beta',  slug: 'project-beta'  },
  { id: '3', name: 'Project Gamma', slug: 'project-gamma' },
];

export const LOCALES = {
  'en-US': enUS,
  ru,
  uk,
};
